import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LandPurposesApi from '@/services/apiServiceModules/landPurposesApi.js'
const landPurposesApi = new LandPurposesApi()

export default class LandPurposesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LAND_PURPOSES, landPurposesApi, {
			useCache: true,
		})
	}
}
